export default __webpack_public_path__ + "static/media/dot_orange.72ad4205.jpg";